import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate';
export default createStore({
  plugins: [createPersistedState()],
  state: {
    historyLevel: 0,  // 页面层级，默认是0
    type: 0,
    mobile: '',
    appid: '',
    routeData: {},
    curTab: ''
  },
  getters: {

  },
  mutations: {
    setHistoryLevel (state, level) {
      state.historyLevel = level;
    },
    setCustomerType (state, level) {
      state.type = level;
    },
    setMobile (state, level) {
      state.mobile = level;
    },
    setAppid (state, level) {
      state.appid = level;
    },
    setRouteData (state, level) {
      state.routeData = level;
    },
    clearRouteData (state, key) {
      if (key) {
        delete state.routeData[key]
      } else {
        state.routeData = {}
      }
    },
    setTab (state, level) {
      state.curTab = level;
    },
  },
  actions: {
    initPage ({ commit }) {
      // 初始化页面时，设置是否从 App 进入
      commit('setHistoryLevel', 0);  // 初始设置为一级页面
    },
    firstPage ({ commit }) {
      // 初始化页面时，设置是否从 App 进入
      commit('setHistoryLevel', 1);  // 初始设置为一级页面
    },
    secondPage ({ commit }) {
      commit('setHistoryLevel', 2);  // 进入二级页面
    },
    customer ({ commit }, data) {
      commit('setCustomerType', data);
    },
    mobile ({ commit }, data) {
      commit('setMobile', data);
    },
    appid ({ commit }, data) {
      commit('setAppid', data);
    },
    routeData ({ commit }, data) {
      commit('setRouteData', data);
    },
    clearRouteData ({ commit }, key) {
      commit('clearRouteData', key)
    },
    curTab ({ commit }, data) {
      commit('setTab', data);
    },
  },
  modules: {
  }
})
